import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", { href: $setup.url }, [
    _createTextVNode(_toDisplayString($props.label) + " ", 1),
    _cache[0] || (_cache[0] = _createElementVNode("em", { class: "fas fa-location-arrow" }, null, -1))
  ], 8, _hoisted_1))
}